import ChangePassword from '@/containers/Setting/ChangePassword'

export default {
  path: 'setting',
  children: [
    { path: 'changePassword', component: ChangePassword }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/setting.js